/** Panel ids for react-resizable-panels layout persistence. */
export const MAIN_PANEL_ID = 'main';
export const DRAWER_PANEL_ID = 'drawer';

export const PAGE_DRAWER_GROUP_ID = 'page-drawer';

/** Layout when drawer is closed: main 100%, drawer 0%. */
export const defaultLayoutClosed = { [MAIN_PANEL_ID]: 100, [DRAWER_PANEL_ID]: 0 };

export const PANEL_IDS = [MAIN_PANEL_ID, DRAWER_PANEL_ID] as const;
